import * as tslib_1 from "tslib";
import { State, Action, Selector } from "@ngxs/store";
import { JbpAction_comment, JbpAction_create, JbpAction_draft, JbpAction_export, JbpAction_download_pdf, JbpAction_getActions, JbpAction_getItems, JbpAction_getPriority, JbpAction_getStrategies, JbpAction_update, } from "./jbp.actions";
import { JbpService } from "../services/jbp.service";
import { tap } from "rxjs/operators";
import { Observable, of } from "rxjs";
import * as moment from "moment";
export class JbpStateModel {
}
let JbpState = class JbpState {
    constructor(jbpService) {
        this.jbpService = jbpService;
    }
    static calculatorValue({ addForm }) {
        const data1 = Number(addForm.model.step4.calculatorTwo) *
            Number(addForm.model.step4.calculatorThree) *
            12;
        const data2 = Number(addForm.model.step4.calculatorTwo) *
            Number(addForm.model.step4.calculatorThree) *
            moment().weeksInYear();
        return {
            data: {
                weeks_12: data1,
                year: data2,
            },
        };
    }
    static data({ list }) {
        return list.data;
    }
    static priority({ priority }) {
        return priority;
    }
    static calculatorTexts({ calculatorTexts, addForm, }) {
        const priorityId = addForm.model.step3.priority;
        return calculatorTexts[priorityId.id - 1];
    }
    static strategies({ strategies, addForm, }) {
        const priorityId = addForm.model.step3.priority;
        return strategies[priorityId.id];
    }
    static actionsOffline({ actions, addForm, }) {
        const strategyId = addForm.model.step3.strategies;
        return actions[strategyId.id].offline;
    }
    static actionsOnline({ actions, addForm, }) {
        const strategyId = addForm.model.step3.strategies;
        return actions[strategyId.id].online;
    }
    getItems({ getState, patchState }, { data }) {
        if (data.page) {
            patchState({
                list: Object.assign({}, getState().list, { params: Object.assign({}, getState().list.params, { page: data.page }) }),
            });
        }
        if (data.filters) {
            patchState({
                list: Object.assign({}, getState().list, { filters: Object.assign({}, getState().list.filters, data.filters) }),
            });
        }
        const params = getState().list.params;
        const filters = getState().list.filters;
        return this.jbpService
            .getItems(Object.assign({}, params, filters))
            .pipe(tap((val) => {
            patchState({
                list: {
                    data: val,
                    params,
                    filters,
                },
            });
        }));
    }
    getPriority({ getState, patchState }) {
        const pioryty = getState().priority;
        if (pioryty.length > 0) {
            return of(pioryty);
        }
        return this.jbpService.getPriority().pipe(tap((val) => {
            patchState({
                priority: val,
            });
        }));
    }
    getStrategies({ getState, patchState }, { priorityId }) {
        const strategies = getState().strategies;
        // if (strategies[priorityId] && strategies[priorityId].length > 0) {
        //   return of(strategies[priorityId]);
        // }
        return this.jbpService.getStrategies(priorityId).pipe(tap((val) => {
            console.log(val);
            patchState({
                strategies: Object.assign({}, strategies, { [priorityId]: val }),
            });
        }));
    }
    getActions({ getState, patchState }, { priorityId }) {
        const actions = getState().actions;
        // if (actions[priorityId] && actions[priorityId]) {
        //   return of(actions[priorityId]);
        // }
        return this.jbpService.getActions(priorityId).pipe(tap((val) => {
            console.log(val);
            patchState({
                actions: Object.assign({}, actions, { [priorityId]: val }),
            });
        }));
    }
    create({ getState, patchState }) {
        const data = Object.assign({}, getState().addForm.model.step2, getState().addForm.model.step4, { priority: getState().addForm.model.step3.priority["id"], actionOffline: getState().addForm.model.step3.actionOffline["id"], actionOnline: getState().addForm.model.step3.actionOnline["id"], client: getState().addForm.model.step1.client["id"], otherActions: getState().addForm.model.step3.otherActions });
        return this.jbpService.create(data);
    }
    update({ getState }, { id }) {
        console.log(getState());
        const data = Object.assign({}, getState().updateForm.model);
        return this.jbpService.update(data, id);
    }
    comment({ getState, patchState }, { id, comment }) {
        return this.jbpService.comment(id, comment);
    }
    draft({ getState, patchState }, { id, draft }) {
        return this.jbpService.draft(id, draft);
    }
    export({ getState, patchState }, { data }) {
        return this.jbpService.export(data);
    }
    exportPdf({ getState, patchState }, { id, clientName }) {
        return this.jbpService.downloadPdf(id, clientName);
    }
};
tslib_1.__decorate([
    Action(JbpAction_getItems),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, JbpAction_getItems]),
    tslib_1.__metadata("design:returntype", void 0)
], JbpState.prototype, "getItems", null);
tslib_1.__decorate([
    Action(JbpAction_getPriority),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], JbpState.prototype, "getPriority", null);
tslib_1.__decorate([
    Action(JbpAction_getStrategies),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, JbpAction_getStrategies]),
    tslib_1.__metadata("design:returntype", void 0)
], JbpState.prototype, "getStrategies", null);
tslib_1.__decorate([
    Action(JbpAction_getActions),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, JbpAction_getActions]),
    tslib_1.__metadata("design:returntype", void 0)
], JbpState.prototype, "getActions", null);
tslib_1.__decorate([
    Action(JbpAction_create),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], JbpState.prototype, "create", null);
tslib_1.__decorate([
    Action(JbpAction_update),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, JbpAction_update]),
    tslib_1.__metadata("design:returntype", void 0)
], JbpState.prototype, "update", null);
tslib_1.__decorate([
    Action(JbpAction_comment),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, JbpAction_comment]),
    tslib_1.__metadata("design:returntype", void 0)
], JbpState.prototype, "comment", null);
tslib_1.__decorate([
    Action(JbpAction_draft),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, JbpAction_draft]),
    tslib_1.__metadata("design:returntype", void 0)
], JbpState.prototype, "draft", null);
tslib_1.__decorate([
    Action(JbpAction_export),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, JbpAction_export]),
    tslib_1.__metadata("design:returntype", void 0)
], JbpState.prototype, "export", null);
tslib_1.__decorate([
    Action(JbpAction_download_pdf),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, JbpAction_download_pdf]),
    tslib_1.__metadata("design:returntype", Observable)
], JbpState.prototype, "exportPdf", null);
tslib_1.__decorate([
    Selector(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [JbpStateModel]),
    tslib_1.__metadata("design:returntype", Object)
], JbpState, "calculatorValue", null);
tslib_1.__decorate([
    Selector(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [JbpStateModel]),
    tslib_1.__metadata("design:returntype", Object)
], JbpState, "data", null);
tslib_1.__decorate([
    Selector(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [JbpStateModel]),
    tslib_1.__metadata("design:returntype", Array)
], JbpState, "priority", null);
tslib_1.__decorate([
    Selector(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [JbpStateModel]),
    tslib_1.__metadata("design:returntype", Array)
], JbpState, "calculatorTexts", null);
tslib_1.__decorate([
    Selector(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [JbpStateModel]),
    tslib_1.__metadata("design:returntype", Array)
], JbpState, "strategies", null);
tslib_1.__decorate([
    Selector(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [JbpStateModel]),
    tslib_1.__metadata("design:returntype", Array)
], JbpState, "actionsOffline", null);
tslib_1.__decorate([
    Selector(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [JbpStateModel]),
    tslib_1.__metadata("design:returntype", Array)
], JbpState, "actionsOnline", null);
JbpState = tslib_1.__decorate([
    State({
        name: "jbp",
        defaults: {
            calculatorTexts: [
                [
                    "Aktualna l. nowych klientów tygodniowo na salon",
                    "Średni paragon",
                    "Oczekiwana dodatkowa l. nowych klientów tygodniowo na salon",
                ],
                [
                    "Średnia l. klientów zapisanych z wizyty na wizytę w tygodniu",
                    "Średni paragon",
                    "Oczekiwana dodatkowa l. klientów z zapisem na kolejny termin tygodniowo na salon",
                ],
                [
                    "Aktualna l. koloryzacji w tygodniu",
                    "Średnia cena koloryzacji",
                    "Oczekiwana dodatkowa l. koloryzacji w tygodniu",
                ],
                [
                    "Aktualna l. sprzedawanych produktów w tygodniu",
                    "Średnia cena produktu na półce",
                    "Oczekiwana dodatkowa l. sprzedawanych produktów w tygodniu",
                ],
                [
                    "Aktualna l. pielęgnacji w tygodniu",
                    "Średnia cena pielęgnacji",
                    "Oczekiwana dodatkowa l. pielęgnacji w tygodniu",
                ],
            ],
            list: {
                params: {
                    direction: "desc",
                    page: 1,
                    perPage: 12,
                    sort: "id",
                },
            },
            priority: [],
            strategies: {},
            actions: {},
        },
    }),
    tslib_1.__metadata("design:paramtypes", [JbpService])
], JbpState);
export { JbpState };
